import { useRef, useEffect } from "react";

export const useInfiniteScroll = (
  callback,
  isLoading = false,
  isLastPage = false
) => {
  const observerRef = useRef(null);

  useEffect(() => {
    if (isLoading || isLastPage) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          callback();
        }
      },
      { threshold: 0.1 }
    );

    const currentRef = observerRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
      observer.disconnect();
    };
  }, [isLoading, isLastPage, callback]);

  return observerRef;
};
